import React, { useRef } from 'react';
import { useSpring, animated } from 'react-spring';

const Blob = ({ color }) => {
    const blobRef = useRef();

    const animation = useSpring({
        from: { left: 0, top: 0 },
        to: async (next) => {
            while (true) {
                await next({
                    left: Math.random() * window.innerWidth,
                    top: Math.random() * window.innerHeight,
                });
            }
        },
        config: { duration: 4000 }, // Add a timing of 10 seconds
        delay: 0, // Optional delay (in milliseconds) before starting the animation
    });


    return (

        <animated.div
            id="blob"
            ref={blobRef}
            style={{
                backgroundColor: color,
                left: animation.left,
                top: animation.top,
            }}
        ></animated.div>
    );
};

export default Blob;